export default __webpack_public_path__ + "static/media/harshit.96f697b2.png";